// src/data/machines.js — UNIT 2 (Heavy) first, UNIT 1 second
export const machines = [
  // ══ UNIT 2 — HEAVY LOAD MACHINES ══
  {
    id: 1,
    unit: 2,
    name: 'BERTHIEZ VTL 8.2m',
    make: 'BERTHIEZ — France',
    type: 'Heavy Duty CNC Vertical Turning Lathe',
    highlight: '🏆 FLAGSHIP — 8.2m swing, 100T table capacity. One of the largest CNC VTLs in South Asia. Used for all major ISRO PSLV and GSLV ring components.',
    image: require('../assets/miltech machine bg remover/VTL-removebg-preview.jpeg'),
    control: 'Siemens 840D',
    specs: {
      'Max. Swing Diameter' : 'Ø 8200 mm',
      'Max. Turning Height' : '4500 mm',
      'Table Diameter'      : '7000 mm',
      'Table Load Capacity' : '100 Tonnes',
      'Spindle Speed'       : 'Variable (CNC)',
      'Control System'      : 'Siemens 840D',
      'Origin'              : 'BERTHIEZ, France',
      'Applications'        : 'ISRO PSLV rings Ø2840mm, Canisters, Large flanges',
    },
  },
  {
    id: 2,
    unit: 2,
    name: 'KOLB Gantry 12.5m',
    make: 'KOLB — Germany',
    type: 'CNC Gantry Floor Boring Machine',
    highlight: '12.5m X-axis German gantry boring machine for very large structural, windmill, and aerospace components.',
    image: require('../assets/miltech machine bg remover/kolb-u2013-germany 8.2m dia.jpeg'),
    control: 'Siemens CNC',
    specs: {
      'X Axis Stroke'   : '14000 mm',
      'Y Axis Stroke'   : '4000 mm',
      'Z Axis Stroke'   : '3500 mm',
      'Spindle Dia'     : '225 mm',
      'Column Distance' : '5500 mm',
      'Control System'  : 'Siemens CNC',
      'Origin'          : 'KOLB, Germany',
      'Applications'    : 'Large structures, Windmill nacelles, Heavy fabrication',
    },
  },
  {
    id: 3,
    unit: 2,
    name: 'EOT Cranes 25T + 10T',
    make: 'Unit 2 Facility',
    type: 'Electric Overhead Travelling Cranes',
    highlight: '25T + 10T tandem EOT cranes for safe handling of massive 100-tonne aerospace components in Unit 2.',
    image: require('../assets/miltech machine bg remover/eot crane 40ton.jpeg'),
    control: 'Pendant / Remote Control',
    specs: {
      'Main Crane Capacity' : '25 Tonnes',
      'Aux. Crane Capacity' : '10 Tonnes',
      'Combined Lift'       : 'Tandem up to 35T',
      'Quantity'            : '2 Nos.',
      'Span'                : 'Full Unit 2 width',
      'Control'             : 'Pendant + Remote',
      'Application'         : 'BERTHIEZ VTL loading, Heavy component handling',
    },
  },

  // ══ UNIT 1 — VMC / LIGHTER CNC MACHINES ══
  {
    id: 4,
    unit: 1,
    name: 'VMC-1 DAHLIH',
    make: 'DAHLIH — Taiwan',
    type: 'Vertical Machining Centre',
    highlight: '3-axis CNC milling centre for medium and large aerospace components with FANUC control system.',
    image: require('../assets/miltech machine bg remover/VMC-1-removebg-preview.png'),
    control: 'FANUC 0-M',
    specs: {
      'Table Size'        : '2000 × 1000 mm (with 4th Axis)',
      'Max. Travel X'     : '1700 mm',
      'Max. Travel Y'     : '800 mm',
      'Max. Travel Z'     : '600 mm',
      'Spindle Speed'     : '8000 RPM',
      'Tool Capacity'     : '20 Tools (ATC)',
      'Control System'    : 'FANUC 0-M',
      'Applications'      : '3D Machining, Milling, Drilling, Boring, Tapping',
    },
  },
  {
    id: 5,
    unit: 1,
    name: 'VMC-2 OKK',
    make: 'OKK — Japan',
    type: 'Vertical Machining Centre (4-Axis)',
    highlight: 'High-precision Japanese 4-axis VMC for complex aerospace profiles and multi-face machining.',
    image: require('../assets/miltech machine bg remover/OKK___Japan-removebg-preview.png'),
    control: 'FANUC',
    specs: {
      'Table Size'        : '1600 × 700 mm',
      'Max. Travel X'     : '1600 mm',
      'Max. Travel Y'     : '800 mm',
      'Max. Travel Z'     : '700 mm',
      'Spindle Speed'     : '10000 RPM',
      '4th Axis'          : 'Rotary Table',
      'Tool Capacity'     : '24 Tools (ATC)',
      'Control System'    : 'FANUC',
      'Applications'      : 'Aerospace components, VMC Job Works, Fixtures, Jigs',
    },
  },
  {
    id: 6,
    unit: 1,
    name: 'VTL Webster Bennett',
    make: 'Webster Bennett — UK',
    type: 'Vertical Turret Lathe',
    highlight: 'British-built heavy-duty VTL for turning large diameter rings, discs, and flanges.',
    image: require('../assets/miltech machine bg remover/WEBSTER_BENNETT-removebg-preview.png'),
    control: 'CNC Retrofit',
    specs: {
      'Chuck Diameter'  : '1200 mm',
      'Max. Swing'      : '1600 mm',
      'Max. Height'     : '2500 mm',
      'Table Speed'     : 'Variable',
      'Control System'  : 'CNC Retrofit',
      'Applications'    : 'Large rings, Discs, Flanges, Hubs',
    },
  },
  {
    id: 7,
    unit: 1,
    name: 'SNK RB-3V',
    make: 'SNK — Japan',
    type: 'CNC Boring & Milling Machine',
    highlight: 'Heavy-duty Japanese floor-type boring mill for large aerospace structural components.',
    image: require('../assets/miltech machine bg remover/SNK-VMC.webp'),
    control: 'Mitsubishi CNC',
    specs: {
      'Table Size'     : '3350 × 3000 mm',
      'X Travel'       : '3000 mm',
      'Y Travel'       : '2500 mm',
      'Z Travel'       : '1200 mm',
      'Spindle Bore'   : 'Ø 130 mm',
      'Max. Load'      : '10 Tonnes',
      'Control System' : 'Mitsubishi CNC',
      'Applications'   : 'Boring, Milling, Turning, Drilling',
    },
  },
  {
    id: 8,
    unit: 1,
    name: 'EOT Crane 4T',
    make: 'Unit 1 Facility',
    type: 'Electric Overhead Travelling Crane',
    highlight: '4-ton EOT crane for safe and precise positioning of large workpieces across Unit 1.',
    image: require('../assets/miltech machine bg remover/eot crane 40ton.jpeg'),
    control: 'Pendant / Remote Control',
    specs: {
      'Capacity'    : '4 Tonnes',
      'Type'        : 'EOT Crane',
      'Quantity'    : '1 No.',
      'Span'        : 'Full factory width',
      'Control'     : 'Pendant + Remote',
      'Application' : 'Component handling, Machine loading',
    },
  },
];

// Bottom summary text
export const unitSummary = {
  1: 'Berthiez CNC VTL Diameter 8200mm · CNC Gantry Floor Boring M/C 16000 × 4000 × 3500',
  2: 'VMC Table 2000 × 1000 With 4th Axis · CNC & VMC Machines · TIG, CO2, Arc Welding',
};